import { Rutas } from '@/constants/rutas';
import { SITE_USER_COOKIE } from '@/constants/site';
import { SUBSCRIPTION_TYPE } from '@/constants/subscription-type';

import { getFromCookies, removeFromCookies } from './cookies';

export const adsHelper = {
    addAdsense: (attempt = 0) => {
        const retryTimes = [100, 1000, 2000, 3000, 4000]; // Tiempos de retry en ms
        const maxAttempts = retryTimes.length; // Máximo de intentos

        setTimeout(() => {
            // Verificar si el script de AdSense está cargado
            if (typeof window.adsbygoogle === 'undefined') {
                if (attempt < maxAttempts) {
                    adsHelper.addAdsense(attempt + 1);
                }
                return;
            }

            let ads = document.getElementsByClassName('adsbygoogle');
            let adsInitialized = 0;

            // Intentar inicializar los anuncios
            for (let i = 0; i < ads.length; i++) {
                if (!ads[i].hasAttribute('data-adsbygoogle-status')) {
                    try {
                        (adsbygoogle = window.adsbygoogle || []).push({});
                        adsInitialized++;
                    } catch (_error) {}
                }
            }

            // Si no se encontraron anuncios o no se inicializó ninguno y aún hay intentos disponibles
            if (adsInitialized === 0 && attempt < maxAttempts) {
                adsHelper.addAdsense(attempt + 1);
            }
        }, retryTimes[attempt]);
    },
    initSingleAdsenseBlock: (element) => {
        if (!element) return;

        if (typeof window.adsbygoogle === 'undefined') {
            console.warn('AdSense script aún no está cargado.');
            return;
        }

        try {
            if (!element.getAttribute('data-adsbygoogle-status')) {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            }
        } catch (error) {
            console.error('❌ Error al inicializar AdSense:', error);
        }
    },
};

export const addAdsenseScript = () => {
    // Obtén el contenedor de scripts por su ID
    const adsScriptsContainer = document.getElementById('ads-scripts');

    if (!adsScriptsContainer) return;

    const adsenseScript = document.createElement('script');
    adsenseScript.async = true;
    adsenseScript.src =
        'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1884623822045383';
    adsenseScript.crossOrigin = 'anonymous';
    // adsenseScript.setAttribute('data-overlays', 'bottom');

    adsScriptsContainer.appendChild(adsenseScript);
};

export const addVideooTvScript = () => {
    // Obtén el contenedor de scripts por su ID
    const adsScriptsContainer = document.getElementById('ads-scripts');

    if (!adsScriptsContainer) return;

    const videooScript = document.createElement('script');
    videooScript.defer = true;
    videooScript.id = 'display-library';
    videooScript.setAttribute('data-id', '5304a3dd388955b75ae57876347218c2a9e687f78faa26c74b806896a80290cf');
    videooScript.setAttribute('data-cfasync', 'false');
    videooScript.src =
        'https://display.videoo.tv/5304a3dd388955b75ae57876347218c2a9e687f78faa26c74b806896a80290cf.js';

    adsScriptsContainer.appendChild(videooScript);
};

export const addAdManagerScript = () => {
    // Verificar si el script ya está cargado
    if (document.querySelector('script[src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"]')) {
        return;
    }

    // Obtener el contenedor de scripts
    const adsScriptsContainer = document.getElementById('ads-scripts');
    if (!adsScriptsContainer) return;

    // Crear el script de Ad Manager
    const adManagerScript = document.createElement('script');
    adManagerScript.async = true;
    adManagerScript.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
    adManagerScript.crossOrigin = 'anonymous';

    // Agregar el script al contenedor
    adManagerScript.onload = () => {
        // Inicializar Google Publisher Tag (GPT)
        window.googletag = window.googletag || { cmd: [] };
        window.googletag.cmd.push(() => {
            window.googletag.pubads().enableSingleRequest();
            window.googletag.enableServices();
        });
    };

    adsScriptsContainer.appendChild(adManagerScript);
};

export const addHbAgencyScript = () => {
    // Obtén el contenedor de scripts por su ID
    const adsScriptsContainer = document.getElementById('ads-scripts');

    if (!adsScriptsContainer) return;

    // Crear el script para configurar el capping del Interstitial
    const cappingScript = document.createElement('script');
    cappingScript.innerHTML = `
        var hbagency_cba = new Array();
        hbagency_cba['hbagency_space_191500'] = 3;
    `;

    // Crear el script de HB Agency
    const hbAgencyScript = document.createElement('script');
    hbAgencyScript.async = true;
    hbAgencyScript.src = 'https://d3u598arehftfk.cloudfront.net/prebid_hb_2640_4004.js';

    // Agregar ambos scripts en orden
    adsScriptsContainer.appendChild(cappingScript);
    adsScriptsContainer.appendChild(hbAgencyScript);
};

export const addGoogleTagManagerAndAnalytics = () => {
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-9D1Z119RGS';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
        dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', 'G-9D1Z119RGS');
};

export const addTaboolaScript = () => {
    // Obtén el contenedor de scripts por su ID
    const adsScriptsContainer = document.getElementById('ads-scripts');

    if (!adsScriptsContainer) return;

    // Evita agregar el script si ya existe
    if (document.getElementById('tb_loader_script')) return;

    // Inicializa el objeto de Taboola si no existe
    window._taboola = window._taboola || [];
    window._taboola.push({ category: 'auto' });

    const script = document.createElement('script');
    script.async = true;
    script.src = '//cdn.taboola.com/libtrc/analiticafantasy-publisher/loader.js';
    script.id = 'tb_loader_script';

    // Inserta el script antes del primer script en el contenedor
    adsScriptsContainer.appendChild(script);

    // Agrega una marca de rendimiento si está disponible
    if (window.performance && typeof window.performance.mark === 'function') {
        window.performance.mark('tbl_ic');
    }
};

export const validateSubscriptions = (subscriptionType) => {
    const dataFromCookies = getFromCookies(SITE_USER_COOKIE);
    const data = JSON.parse(dataFromCookies);

    if (subscriptionType === SUBSCRIPTION_TYPE.FREE) {
        if (data && data.subscriptionType !== SUBSCRIPTION_TYPE.FREE) {
            removeFromCookies(SITE_USER_COOKIE);
            window.location.href = Rutas.INICIO;
        }
    }
};

export const addCleverCoreScript = () => {
    // Obtiene el contenedor de scripts por su ID
    const adsScriptsContainer = document.getElementById('ads-scripts');

    if (!adsScriptsContainer) return;

    const script = document.createElement('script');
    script.async = true;
    script.type = 'text/javascript';
    script.dataset.cfasync = 'false'; // Asegura compatibilidad con Cloudflare
    script.id = 'CleverCoreLoader89156';
    script.src = 'https://scripts.cleverwebserver.com/5152e780160da6de837938de237d7b82.js';

    // Agrega atributos personalizados
    script.setAttribute(
        'data-target',
        window.name || (window.frameElement && window.frameElement.getAttribute('id'))
    );
    script.setAttribute('data-callback', 'put-your-callback-function-here');
    script.setAttribute('data-callback-url-click', 'put-your-click-macro-here');
    script.setAttribute('data-callback-url-view', 'put-your-view-macro-here');

    // Agrega el script al contenedor
    adsScriptsContainer.appendChild(script);
};

export const removeCleverCoreScript = () => {
    // Obtiene el contenedor de scripts por su ID
    const adsScriptsContainer = document.getElementById('ads-scripts');

    if (!adsScriptsContainer) return;

    // Busca el script por su ID
    const script = document.getElementById('CleverCoreLoader89156');

    if (script) {
        adsScriptsContainer.removeChild(script);
    }
};

export const addVideooTvFifaScript = () => {
    const adsScriptsContainer = document.getElementById('ads-scripts');

    if (!adsScriptsContainer) return;

    const videooScript = document.createElement('script');
    videooScript.defer = true;
    videooScript.id = 'videoo-library';
    videooScript.setAttribute('data-id', '63baf2cd2c718193bfc580c9f92e6ac8cc20e9bf4a17262903eaca6b26ac0d2b');
    videooScript.src =
        'https://static.videoo.tv/63baf2cd2c718193bfc580c9f92e6ac8cc20e9bf4a17262903eaca6b26ac0d2b.js';

    adsScriptsContainer.appendChild(videooScript);
};

export const addAzerionScript = () => {
    const ZID = '40719';
    const sSrc = `https://sac.ayads.co/sublime/${ZID}`;

    try {
        const container = top?.document?.body;
        if (!container) return;

        const existingScript = top.document.querySelector(`script[src="${sSrc}"]`);

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = sSrc;

        if (existingScript) {
            existingScript.remove();
        }

        container.insertBefore(script, container.firstChild);
    } catch (error) {
        console.error('Error injecting Azerion script:', error);
    }
};

export const refreshHbAgencyAds = () => {
    try {
        setTimeout(() => {
            const getAllAdUnits = document.querySelectorAll('[id^="hbagency_space_"]');
            const excludeList = [
                'hbagency_space_176925', // STICKY_BOTTOM
                'hbagency_space_176437', // AF_300x100_MOBILE
                'hbagency_space_211558', // FIXED_BOTTOM
            ];

            if (getAllAdUnits.length === 0) {
                return;
            }

            getAllAdUnits.forEach((adUnit) => {
                if (excludeList.includes(adUnit.id)) {
                    return;
                }
                hbManager.refreshBidHBA(adUnit.id);
            });
        }, 1000);
    } catch (error) {
        console.error('Error refreshing HB Agency ads:', error);
    }
};

export const isAdSlotEmpty = (id) => {
    const el = document.getElementById(id);
    if (!el) return true;

    const isHTMLBlank = el.innerHTML.trim() === '';
    const hasNoChildren = el.children.length === 0;
    const hasNoHeight = el.offsetHeight === 0;

    return isHTMLBlank || hasNoChildren || hasNoHeight;
};

export const loadCleverCoreScript = (id = 'clever-core') => {
    if (document.getElementById(id)) return; // Evita cargarlo dos veces

    const c = document.createElement('script');
    c.id = id;
    c.src = 'https://scripts.cleverwebserver.com/5c64eb1908aa3f7b07b9541c95692291.js';
    c.async = true;
    c.type = 'text/javascript';

    // Atributos opcionales
    const f = window.frameElement;
    c.setAttribute('data-target', window.name || (f && f.getAttribute('id')) || '');
    c.setAttribute('data-callback', 'put-your-callback-function-here');
    c.setAttribute('data-callback-url-click', 'put-your-click-macro-here');
    c.setAttribute('data-callback-url-view', 'put-your-view-macro-here');

    // Insertar antes del primer <script> encontrado o en <head>/<body>
    let a;
    try {
        a = parent.document.getElementsByTagName('script')[0] || document.getElementsByTagName('script')[0];
    } catch (_error) {
        a = null;
    }
    if (!a) {
        a = document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0];
    }
    a.parentNode.insertBefore(c, a);
};

export const loadGptInterstitialScript = (id = 'gpt-interstitial') => {
    if (document.getElementById(id)) return; // Evita cargarlo dos veces

    // Crear el script principal de GPT
    const gptScript = document.createElement('script');
    gptScript.async = true;
    gptScript.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
    gptScript.type = 'text/javascript';

    // Crear el script de configuración del interstitial
    const configScript = document.createElement('script');
    configScript.id = id;
    configScript.type = 'text/javascript';
    configScript.innerHTML = `
        window.googletag = window.googletag || {};
        googletag.cmd = googletag.cmd || [];
        googletag.cmd.push(function() {
            var interstitialSlot = googletag.defineOutOfPageSlot('/22651342849/analiticafantasy.com_interstitial', googletag.enums.OutOfPageFormat.INTERSTITIAL);
            if (interstitialSlot) interstitialSlot.addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.enableServices();
            googletag.display(interstitialSlot);
        });
    `;

    // Insertar antes del primer <script> encontrado o en <head>/<body>
    let a;
    try {
        a = parent.document.getElementsByTagName('script')[0] || document.getElementsByTagName('script')[0];
    } catch (_error) {
        a = null;
    }
    if (!a) {
        a = document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0];
    }

    // Insertar primero el script de GPT y luego el de configuración
    a.parentNode.insertBefore(gptScript, a);
    a.parentNode.insertBefore(configScript, a);
};

export const addStpdScript = () => {
    const adsScriptsContainer = document.getElementById('ads-scripts');
    if (!adsScriptsContainer) return;

    const src = 'https://stpd.cloud/assets/stpdwrapper.js';
    if (document.querySelector(`script[src="${src}"]`)) return;

    const stpdScript = document.createElement('script');
    stpdScript.async = true;
    stpdScript.src = src;
    stpdScript.crossOrigin = 'anonymous';
    stpdScript.onload = () => stpdScript.setAttribute('data-loaded', 'true');

    adsScriptsContainer.appendChild(stpdScript);
};

export const addIntersitialVideooTvScript = () => {
    // Verificar si el script ya existe
    if (document.getElementById('videoo-library')) {
        return;
    }

    // Crear el elemento script
    const script = document.createElement('script');
    script.defer = true;
    script.id = 'videoo-library';
    script.setAttribute('data-cfasync', 'false');
    script.setAttribute('data-id', '63baf2cd2c718193bfc580c9f92e6ac8cc20e9bf4a17262903eaca6b26ac0d2b');
    script.src =
        'https://static.videoo.tv/63baf2cd2c718193bfc580c9f92e6ac8cc20e9bf4a17262903eaca6b26ac0d2b.js';

    // Agregar el script al head del documento
    document.head.appendChild(script);
};
